import * as React from 'react';
import { ImageIcon } from 'lucide-react';
import { cn } from '../../lib/utils';

export interface ThumbProps {
  src?: string | null;
  alt?: string;
  /** `sm` for list rows, `lg` for line items in a detail panel. */
  size?: 'sm' | 'lg';
  className?: string;
}

const sizes = {
  sm: 'h-7 w-7 rounded-md',
  lg: 'h-11 w-11 rounded-lg',
} as const;

/**
 * The picture beside a row. Without an image it stays a quiet filled square
 * rather than a large grey icon — the row is about the name, and a placeholder
 * that shouts reads as a broken image.
 */
export const Thumb: React.FC<ThumbProps> = ({ src, alt = '', size = 'sm', className }) => (
  <span
    className={cn(
      'inline-flex shrink-0 items-center justify-center overflow-hidden border border-border bg-muted',
      sizes[size],
      className,
    )}
  >
    {src ? (
      <img src={src} alt={alt} className="h-full w-full object-cover" />
    ) : (
      // A faint glyph, not a bare square: an empty square at the start of a
      // table row reads as a checkbox.
      <ImageIcon
        aria-hidden="true"
        className={cn('text-muted-foreground/35', size === 'sm' ? 'h-3.5 w-3.5' : 'h-5 w-5')}
      />
    )}
  </span>
);
